import { Component, inject, Input, OnInit } from '@angular/core';
import { Company, CompanyEnum } from '../../models/company.model';
import { ButtonComponent } from '@lx/shared/ui/button';
import { COMPANY_LOGO_PATH_PREFIX } from '../../utils/constant';
import { CommonModule } from '@angular/common';
import { ActionButton } from '../../models/types';
import { SharedDataStore } from '../../store';
import { Observable } from 'rxjs';
import { PriceListYear } from '../../models';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  standalone: true,
  imports: [CommonModule, ButtonComponent, DropdownModule, FormsModule],
  selector: 'lx-price-lists-portal-price-lists-header',
  templateUrl: './pricelists-header.component.html',
  styleUrls: ['./pricelists-header.component.scss', './print-pricelists-header.component.scss'],
})
export class PriceListsHeaderComponent implements OnInit {
  @Input() buttons: ActionButton[] = [];

  CompanyEnum = CompanyEnum;

  kaplanCompanyLogoPath = `${COMPANY_LOGO_PATH_PREFIX}${CompanyEnum.KIL}.svg`;
  alpadiaCompanyLogoPath = `${COMPANY_LOGO_PATH_PREFIX}${CompanyEnum.ALP}-30.svg`;
  company$: Observable<Company> | undefined;
  priceListYears$: Observable<PriceListYear[] | undefined>;
  currentYear$: Observable<string | undefined>;

  private readonly sharedDataStore = inject(SharedDataStore);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);

  ngOnInit() {
    this.company$ = this.sharedDataStore.company$;
    this.priceListYears$ = this.sharedDataStore.priceListYears$;
    this.currentYear$ = this.sharedDataStore.currentPriceListYear$;
  }

  onYearChange(selectedYear: string) {
    this.router.navigate([selectedYear], { relativeTo: this.route }).then(() => {
      // do nothing
    });
  }
}
